import { render, staticRenderFns } from "./SsoLogin.vue?vue&type=template&id=b338c378&"
import script from "./SsoLogin.vue?vue&type=script&lang=js&"
export * from "./SsoLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b338c378')) {
      api.createRecord('b338c378', component.options)
    } else {
      api.reload('b338c378', component.options)
    }
    module.hot.accept("./SsoLogin.vue?vue&type=template&id=b338c378&", function () {
      api.rerender('b338c378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Pages/SsoLogin.vue"
export default component.exports